import React from 'react';
import { Box, Icon, Text, HStack } from '@medely/ui-kit';

interface MfaErrorAlertProps {
  message: string;
  visible: boolean;
}

export const MfaErrorAlert = ({ message, visible }: MfaErrorAlertProps) => {
  if (!visible) {
    return null;
  }

  return (
    <HStack
      alignItems="center"
      gap={1}
      bgColor="state.error.backing-1"
      borderRadius="14px"
      p={3}
      mb={4}
    >
      <Icon name="solid-circle-exclamation" color="state.error.secondary" variant="custom" />
      <Box flex={1}>
        <Text size="m" color="state.error.primary">
          {message}
        </Text>
      </Box>
    </HStack>
  );
};
